import { baseQuery } from "./baseQuery";
import { createApi } from "@reduxjs/toolkit/query/react";
import { WebhookRequest } from "../shared/models/webhook.model";

export const webhookService = createApi({
  reducerPath: "webhookService",
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getWebhooks: builder.query<any, WebhookRequest>({
      query: (params) => ({
        url: `/communication-settings/${params?.partnerId}/webhook`,
        params,
        method: "GET",
        headers: {
          PageName: "Webhook Service",
        },
      }),
    }),
    testWebhooks: builder.mutation<any, { webhook_url: string }>({
      query: (params) => ({
        url: `/communication-settings/webhook/test`,
        params,
        method: "GET",
        headers: {
          PageName: "Webhook Service",
        },
      }),
    }),
    getEventsSelect: builder.query<any, any>({
      query: () => ({
        url: `/communication-settings/webhook/events`,
        method: "GET",
        headers: {
          PageName: "Webhook Service",
        },
      }),
    }),
    getDetailWebhook:  builder.mutation<any, { hashId: string; partnerId: number }>({
      query: (params) => ({
        url: `/communication-settings/${params?.partnerId}/webhook/${params?.hashId}`,
        method: "GET",
        headers: {
          PageName: "Webhook Service",
        },
      }),
    }),
    createWebhook: builder.mutation<any, any>({
      query: (params) => ({
        url: `/communication-settings/${params?.partner_id}/webhook`,
        body: params,
        method: "POST",
        headers: {
          PageName: "Webhook Service",
        },
      }),
    }),
    updateWebhook: builder.mutation<any, any>({
      query: (params) => ({
        url: `/communication-settings/${params?.partner_id}/webhook/${params?.hash_id}`,
        body: params,
        method: "PUT",
        headers: {
          PageName: "Webhook Service",
        },
      }),
    }),
    deleteWebhook: builder.mutation<any, { hashId: string; partnerId: number }>({
      query: (params) => ({
        url: `/communication-settings/${params?.partnerId}/webhook/${params?.hashId}`,
        params,
        method: "DELETE",
        headers: {
          PageName: "Webhook Service",
        },
      }),
    }),
  }),
});

export const {
  useGetWebhooksQuery,
  useLazyGetWebhooksQuery,
  useTestWebhooksMutation,
  useGetEventsSelectQuery,
  useGetDetailWebhookMutation,
  useCreateWebhookMutation,
  useUpdateWebhookMutation,
  useDeleteWebhookMutation,
} = webhookService;
